import React from 'react'
//@ts-ignore
import s from './LoaderConfig.module.scss'

export const LoaderConfig = () => {


    return (
        <div className={s.loader_wrap} >

            <div className={s.lds_facebook}>
                <div className={s.loader_item}></div>
                <div className={s.loader_item}></div>
                <div className={s.loader_item}></div>
                <div className={s.loader_item}></div>
                <div className={s.loader_item}></div>
            </div>

        </div>

    )
}
